<script setup lang="ts">
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/cms/components/ui/popover/index.ts";
import { PopoverProps } from "@/cms/components/Popover/Popover.types.ts";
import { computed } from "vue";
import { BODY_TARGET_IDS } from "@/util/constants.ts";

const props = withDefaults(defineProps<PopoverProps>(), {
  disabled: false,
  side: "bottom",
  align: "center",
  matchTriggerWidth: false,
  noContentPadding: false,
  contentLabel: undefined,
});

const isOpen = defineModel({ type: Boolean, default: false });

const triggerCursorStyle = computed(() =>
  props.disabled ? "not-allowed" : "pointer"
);

const popoverContentStyle = computed(() => {
  if (props.matchTriggerWidth) {
    return "width: var(--radix-popover-trigger-width)";
  }

  return "";
});
</script>

<template>
  <Popover v-model:open="isOpen">
    <PopoverTrigger :disabled v-bind="$attrs" :as-child>
      <slot name="trigger" />
    </PopoverTrigger>
    <PopoverContent
      :align
      :side
      :to="`#${BODY_TARGET_IDS.tailwindModalTarget}`"
      :style="popoverContentStyle"
      :class="{ 'p-0': noContentPadding }"
      :aria-label="contentLabel"
    >
      <slot name="content" />
    </PopoverContent>
  </Popover>
</template>

<style scoped lang="scss">
:deep(button) {
  cursor: v-bind(triggerCursorStyle);
}
</style>
